import { ColorPicker } from 'antd';

const CustomColorPicker: React.FC<any> = ({ onChange, ...rest }) => (
	<ColorPicker
		{...rest}
		showText
		// color={value}
		onChange={c => {
			onChange(`#${c.toHex()}`);
		}}
	/>
);

export default CustomColorPicker;
